import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Address } from '../../models';

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnInit {
    public form!: FormGroup;

    @Input()
    public set _address(value: Address) {
        const interval = setInterval(() => {
            if (this.form) {
                this.form.patchValue(value);
                clearInterval(interval);
            }
        }, 1000);
    }

    public roadTypes: Array<string> = [
        'AVENIDA',
        'BULEVAR',
        'AUTOPISTA',
        'AVENIDA CALLE',
        'AVENIDA CARRERA',
        'CALLE',
        'CARRERA',
        'CARRETERA',
        'CIRCULAR',
        'CIRCUNVALAR',
        'CUENTAS CORRIDAS',
        'DIAGONAL',
        'KILÓMETRO',
        'PASAJE',
        'PASEO',
        'PEATONAL',
        'TRANSVERSAL',
        'TRONCAL',
        'VARIANTE',
        'VÍA',
    ];
    public letras: Array<string> = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    public referenciaCardinal: Array<string> = ['NORTE', 'OESTE', 'ESTE', 'SUR', 'OCCIDENTE', 'ORIENTE'];

    private get via(): string {
        return this.form.get('via')?.value;
    }
    private get numero_via_principal(): string {
        return this.form.get('numero_via_principal')?.value;
    }
    private get letra_via_principal(): string {
        return this.form.get('letra_via_principal')?.value;
    }
    private get prefijo(): string {
        return this.form.get('prefijo')?.value;
    }
    private get acompanante_prefijo(): string {
        return this.form.get('acompanante_prefijo')?.value;
    }
    private get cuadrante(): string {
        return this.form.get('cuadrante')?.value;
    }
    private get numero_via_generadora(): string {
        return this.form.get('numero_via_generadora')?.value;
    }
    private get acompanante_numero_via_generadora(): string {
        return this.form.get('acompanante_numero_via_generadora')?.value;
    }
    private get sufijo(): string {
        return this.form.get('sufijo')?.value;
    }
    private get numero_placa(): string {
        return this.form.get('numero_placa')?.value;
    }
    private get cuadrante_2(): string {
        return this.form.get('cuadrante_2')?.value;
    }

    get address() {
        return `${this.via||''} ${this.numero_via_principal || ''}${this.letra_via_principal || ''} ${this.prefijo || ''} ${this.acompanante_prefijo || ''} ${this.cuadrante || ''} ${
            this.numero_via_generadora ? `#${this.numero_via_generadora || ''}` : ''
        }${this.acompanante_numero_via_generadora || ''}${this.sufijo || ''}${this.numero_placa ? `-${this.numero_placa||''}` : ''} ${this.cuadrante_2 || ''} Bogotá`
            .replace(/\s+/g, ' ')
            .trim();
    }

    @Output() searchAddress: EventEmitter<{ address: string; valueForm: any }> = new EventEmitter<{ address: string; valueForm: any }>();
    constructor() {}

    ngOnInit(): void {
        this.createForm();
    }
    createForm() {
        this.form = new FormGroup({
            via: new FormControl(undefined, [Validators.required]),
            numero_via_principal: new FormControl(undefined, [Validators.required, Validators.maxLength(3), Validators.pattern('^[0-9]+$')]),
            letra_via_principal: new FormControl(),
            prefijo: new FormControl(),
            acompanante_prefijo: new FormControl(),
            cuadrante: new FormControl(),
            numero_via_generadora: new FormControl(undefined, [Validators.required, Validators.maxLength(3), Validators.pattern('^[0-9]+$')]),
            acompanante_numero_via_generadora: new FormControl(),
            sufijo: new FormControl(),
            numero_placa: new FormControl(undefined, [Validators.required, Validators.maxLength(3), Validators.pattern('^[0-9]+$')]),
            cuadrante_2: new FormControl(),
        });
    }
    search() {
        this.searchAddress.emit({ address: this.address, valueForm: this.form.value });
    }
}
